import { render, staticRenderFns } from "./TempletCombinationStyle.vue?vue&type=template&id=80fe1e76&scoped=true&"
import script from "./TempletCombinationStyle.vue?vue&type=script&lang=js&"
export * from "./TempletCombinationStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fe1e76",
  null
  
)

export default component.exports